declare namespace $ {

	export class $shm_hitalama_project_codex extends $shm_codex_app {
		width( next?: number ): number
		width_px( ): string
		project_id( ): string
		style( ): ({ 
			'width': ReturnType< $shm_hitalama_project_codex['width_px'] >,
			'flexBasis': ReturnType< $shm_hitalama_project_codex['width_px'] >,
			'flexGrow': number,
			'flexShrink': number,
			'minWidth': string,
		})  & ReturnType< $shm_codex_app['style'] >
	}
	
}

//# sourceMappingURL=codex.view.tree.d.ts.map